var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "c-office-filter__sticky-wrapper" }, [
      _c("div", { staticClass: "c-office-filter o-width-limiter--full" }, [
        _c("div", { staticClass: "c-office-filter__wrapper" }, [
          _c("div", { staticClass: "c-office-filter__content-wrapper" }, [
            _c("h1", [_vm._v(_vm._s(this.translate.findpremise))]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "c-office-filter__dropdown-wrapper" },
              [
                _c(
                  "v-office-filter-dropdown",
                  {
                    attrs: {
                      tag: "plats",
                      "button-text": _vm.placesButtonText,
                      "select-area": this.translate.selectarea,
                      select: this.translate.select,
                      selecttag: this.translate.selectarealabel,
                      "dropdown-open": this.activeFilter === "plats",
                    },
                    on: { "populate-filter": _vm.handleFilterData },
                  },
                  [
                    this.activeFilter === "plats"
                      ? _c(
                          "ul",
                          {
                            directives: [
                              {
                                name: "click-outside",
                                rawName: "v-click-outside",
                                value: _vm.handleClickOutside,
                                expression: "handleClickOutside",
                              },
                            ],
                            staticClass: "c-office-filter-dropdown__list",
                          },
                          _vm._l(_vm.cities, function (city) {
                            return _vm.activeFilter === "plats"
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "c-office-filter__city-wrapper",
                                  },
                                  [
                                    !_vm.singleCity
                                      ? _c(
                                          "li",
                                          {
                                            staticClass:
                                              "c-office-filter__city",
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.addRegions(city)
                                                  },
                                                },
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.selectedPlaces,
                                                      expression:
                                                        "selectedPlaces",
                                                    },
                                                  ],
                                                  attrs: { type: "checkbox" },
                                                  domProps: {
                                                    value: city.value,
                                                    checked: Array.isArray(
                                                      _vm.selectedPlaces
                                                    )
                                                      ? _vm._i(
                                                          _vm.selectedPlaces,
                                                          city.value
                                                        ) > -1
                                                      : _vm.selectedPlaces,
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      var $$a =
                                                          _vm.selectedPlaces,
                                                        $$el = $event.target,
                                                        $$c = $$el.checked
                                                          ? true
                                                          : false
                                                      if (Array.isArray($$a)) {
                                                        var $$v = city.value,
                                                          $$i = _vm._i($$a, $$v)
                                                        if ($$el.checked) {
                                                          $$i < 0 &&
                                                            (_vm.selectedPlaces =
                                                              $$a.concat([$$v]))
                                                        } else {
                                                          $$i > -1 &&
                                                            (_vm.selectedPlaces =
                                                              $$a
                                                                .slice(0, $$i)
                                                                .concat(
                                                                  $$a.slice(
                                                                    $$i + 1
                                                                  )
                                                                ))
                                                        }
                                                      } else {
                                                        _vm.selectedPlaces = $$c
                                                      }
                                                    },
                                                  },
                                                }),
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(city.display) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm._l(_vm.regions, function (region) {
                                      return region.group === city.display
                                        ? _c(
                                            "li",
                                            {
                                              staticClass:
                                                "c-office-filter__region",
                                            },
                                            [
                                              _c("div", [
                                                _c("label", [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.selectedPlaces,
                                                        expression:
                                                          "selectedPlaces",
                                                      },
                                                    ],
                                                    attrs: { type: "checkbox" },
                                                    domProps: {
                                                      value: region.value,
                                                      checked: Array.isArray(
                                                        _vm.selectedPlaces
                                                      )
                                                        ? _vm._i(
                                                            _vm.selectedPlaces,
                                                            region.value
                                                          ) > -1
                                                        : _vm.selectedPlaces,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        var $$a =
                                                            _vm.selectedPlaces,
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v =
                                                              region.value,
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              (_vm.selectedPlaces =
                                                                $$a.concat([
                                                                  $$v,
                                                                ]))
                                                          } else {
                                                            $$i > -1 &&
                                                              (_vm.selectedPlaces =
                                                                $$a
                                                                  .slice(0, $$i)
                                                                  .concat(
                                                                    $$a.slice(
                                                                      $$i + 1
                                                                    )
                                                                  ))
                                                          }
                                                        } else {
                                                          _vm.selectedPlaces =
                                                            $$c
                                                        }
                                                      },
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(region.display)
                                                    ),
                                                  ]),
                                                ]),
                                              ]),
                                            ]
                                          )
                                        : _vm._e()
                                    }),
                                  ],
                                  2
                                )
                              : _vm._e()
                          }),
                          0
                        )
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "v-office-filter-dropdown",
                  {
                    attrs: {
                      tag: "lokal",
                      "button-text": _vm.typeOfBuildingButtonText,
                      "select-area": this.translate.selectarea,
                      select: this.translate.select,
                      selecttag: this.translate.selectpremiselabel,
                      "dropdown-open": this.activeFilter === "lokal",
                    },
                    on: { "populate-filter": _vm.handleFilterData },
                  },
                  [
                    this.activeFilter === "lokal"
                      ? _c(
                          "ul",
                          {
                            directives: [
                              {
                                name: "click-outside",
                                rawName: "v-click-outside",
                                value: _vm.handleClickOutside,
                                expression: "handleClickOutside",
                              },
                            ],
                            staticClass: "c-office-filter-dropdown__list",
                          },
                          _vm._l(_vm.premiseType, function (premise) {
                            return _vm.activeFilter === "lokal"
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "c-office-filter__place-wrapper",
                                  },
                                  [
                                    _c(
                                      "li",
                                      { staticClass: "c-office-filter__place" },
                                      [
                                        _c("label", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.selectedTypesOfBuildings,
                                                expression:
                                                  "selectedTypesOfBuildings",
                                              },
                                            ],
                                            attrs: { type: "checkbox" },
                                            domProps: {
                                              value: premise.value,
                                              checked: Array.isArray(
                                                _vm.selectedTypesOfBuildings
                                              )
                                                ? _vm._i(
                                                    _vm.selectedTypesOfBuildings,
                                                    premise.value
                                                  ) > -1
                                                : _vm.selectedTypesOfBuildings,
                                            },
                                            on: {
                                              change: function ($event) {
                                                var $$a =
                                                    _vm.selectedTypesOfBuildings,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = premise.value,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      (_vm.selectedTypesOfBuildings =
                                                        $$a.concat([$$v]))
                                                  } else {
                                                    $$i > -1 &&
                                                      (_vm.selectedTypesOfBuildings =
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          ))
                                                  }
                                                } else {
                                                  _vm.selectedTypesOfBuildings =
                                                    $$c
                                                }
                                              },
                                            },
                                          }),
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(premise.display) +
                                              "\n                    "
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e()
                          }),
                          0
                        )
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "v-office-filter-dropdown",
                  {
                    attrs: {
                      tag: "yta",
                      "button-text": _vm.buildingSizeText,
                      "select-area": this.translate.selectarea,
                      select: this.translate.select,
                      selecttag: this.translate.selectspacelabel,
                      "dropdown-open": this.activeFilter === "yta",
                    },
                    on: { "populate-filter": _vm.handleFilterData },
                  },
                  [
                    this.activeFilter === "yta"
                      ? _c(
                          "ul",
                          {
                            directives: [
                              {
                                name: "click-outside",
                                rawName: "v-click-outside",
                                value: _vm.handleClickOutside,
                                expression: "handleClickOutside",
                              },
                            ],
                            staticClass: "c-office-filter-dropdown__list",
                          },
                          [
                            _vm.activeFilter === "yta"
                              ? _c("div", [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "c-office-filter__size-input-block",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "c-office-filter__size-input-heading",
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                this.translate.showdesiredspace
                                              ) +
                                              "\n                    "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "c-office-filter__size-input-wrapper",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "c-office-filter__size-input-container",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "c-office-filter__size-input-tag",
                                                },
                                                [_vm._v("Min")]
                                              ),
                                              _vm._v(" "),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.minSize,
                                                    expression: "minSize",
                                                  },
                                                ],
                                                staticClass:
                                                  "c-office-filter__size-input",
                                                attrs: {
                                                  type: "number",
                                                  min: "0",
                                                  placeholder: "0",
                                                },
                                                domProps: {
                                                  value: _vm.minSize,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.minSize =
                                                      $event.target.value
                                                  },
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "c-office-filter__size-input-m2-tag",
                                                },
                                                [
                                                  _vm._v("m"),
                                                  _c("sup", [_vm._v("2")]),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "c-icon c-icon--xs c-office-filter-dropdown__toggle-icon",
                                              attrs: { "aria-hidden": "true" },
                                            },
                                            [
                                              _c("svg", [
                                                _c("use", {
                                                  attrs: {
                                                    "xlink:href": `#icon-minus`,
                                                  },
                                                }),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "c-office-filter__size-input-container",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "c-office-filter__size-input-tag",
                                                },
                                                [_vm._v("Max")]
                                              ),
                                              _vm._v(" "),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.maxSize,
                                                    expression: "maxSize",
                                                  },
                                                ],
                                                staticClass:
                                                  "c-office-filter__size-input",
                                                attrs: {
                                                  type: "number",
                                                  min: "0",
                                                  placeholder: "0",
                                                },
                                                domProps: {
                                                  value: _vm.maxSize,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.maxSize =
                                                      $event.target.value
                                                  },
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "c-office-filter__size-input-m2-tag",
                                                },
                                                [
                                                  _vm._v("m"),
                                                  _c("sup", [_vm._v("2")]),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "v-office-filter-dropdown",
                  {
                    attrs: {
                      tag: "arbetsplatser",
                      "button-text": _vm.buildingNumberOfWorkplaces,
                      "select-area": this.translate.selectarea,
                      select: this.translate.select,
                      selecttag: this.translate.selectworkplaceslabel,
                      "dropdown-open": this.activeFilter === "arbetsplatser",
                    },
                    on: { "populate-filter": _vm.handleFilterData },
                  },
                  [
                    this.activeFilter === "arbetsplatser"
                      ? _c(
                          "ul",
                          {
                            directives: [
                              {
                                name: "click-outside",
                                rawName: "v-click-outside",
                                value: _vm.handleClickOutside,
                                expression: "handleClickOutside",
                              },
                            ],
                            staticClass: "c-office-filter-dropdown__list",
                          },
                          [
                            _vm.activeFilter === "arbetsplatser"
                              ? _c("div", [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "c-office-filter__size-input-block",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "c-office-filter__size-input-heading",
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                this.translate
                                                  .showdesiredworkplace
                                              ) +
                                              "\n                    "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "c-office-filter__size-input-wrapper",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "c-office-filter__size-input-container",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "c-office-filter__size-input-tag",
                                                },
                                                [_vm._v("Min")]
                                              ),
                                              _vm._v(" "),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.minNumberOfWorkplaces,
                                                    expression:
                                                      "minNumberOfWorkplaces",
                                                  },
                                                ],
                                                staticClass:
                                                  "c-office-filter__size-input",
                                                attrs: {
                                                  type: "number",
                                                  min: "0",
                                                  placeholder: "0",
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.minNumberOfWorkplaces,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.minNumberOfWorkplaces =
                                                      $event.target.value
                                                  },
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "c-office-filter__size-input-m2-tag",
                                                },
                                                [_vm._v("st")]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "c-icon c-icon--xs c-office-filter-dropdown__toggle-icon",
                                              attrs: { "aria-hidden": "true" },
                                            },
                                            [
                                              _c("svg", [
                                                _c("use", {
                                                  attrs: {
                                                    "xlink:href": `#icon-minus`,
                                                  },
                                                }),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "c-office-filter__size-input-container",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "c-office-filter__size-input-tag",
                                                },
                                                [_vm._v("Max")]
                                              ),
                                              _vm._v(" "),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.maxNumberOfWorkplaces,
                                                    expression:
                                                      "maxNumberOfWorkplaces",
                                                  },
                                                ],
                                                staticClass:
                                                  "c-office-filter__size-input",
                                                attrs: {
                                                  type: "number",
                                                  min: "0",
                                                  placeholder: "0",
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.maxNumberOfWorkplaces,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.maxNumberOfWorkplaces =
                                                      $event.target.value
                                                  },
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "c-office-filter__size-input-m2-tag",
                                                },
                                                [_vm._v("st")]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "clear-choises-button",
                    on: { click: _vm.resetFilter },
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(this.translate.resetchoices || "clear") +
                        "\n            "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm.activeFilter
          ? _c("div", { staticClass: "c-office-filter__choices-container" }, [
              _c(
                "ul",
                { staticClass: "c-office-filter__list" },
                [
                  _vm._l(_vm.cities, function (city) {
                    return _vm.activeFilter === "plats"
                      ? _c(
                          "div",
                          { staticClass: "c-office-filter__city-wrapper" },
                          [
                            !_vm.singleCity
                              ? _c(
                                  "li",
                                  { staticClass: "c-office-filter__city" },
                                  [
                                    _c(
                                      "label",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.addRegionsMobile(city)
                                          },
                                        },
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.selectedPlacesMobile,
                                              expression:
                                                "selectedPlacesMobile",
                                            },
                                          ],
                                          attrs: { type: "checkbox" },
                                          domProps: {
                                            value: city.value,
                                            checked: Array.isArray(
                                              _vm.selectedPlacesMobile
                                            )
                                              ? _vm._i(
                                                  _vm.selectedPlacesMobile,
                                                  city.value
                                                ) > -1
                                              : _vm.selectedPlacesMobile,
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$a =
                                                  _vm.selectedPlacesMobile,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = city.value,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.selectedPlacesMobile =
                                                      $$a.concat([$$v]))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.selectedPlacesMobile =
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        ))
                                                }
                                              } else {
                                                _vm.selectedPlacesMobile = $$c
                                              }
                                            },
                                          },
                                        }),
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(city.display) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(_vm.regions, function (region) {
                              return region.group === city.display
                                ? _c(
                                    "li",
                                    { staticClass: "c-office-filter__region" },
                                    [
                                      _c("label", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.selectedPlacesMobile,
                                              expression:
                                                "selectedPlacesMobile",
                                            },
                                          ],
                                          attrs: { type: "checkbox" },
                                          domProps: {
                                            value: region.value,
                                            checked: Array.isArray(
                                              _vm.selectedPlacesMobile
                                            )
                                              ? _vm._i(
                                                  _vm.selectedPlacesMobile,
                                                  region.value
                                                ) > -1
                                              : _vm.selectedPlacesMobile,
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$a =
                                                  _vm.selectedPlacesMobile,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = region.value,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.selectedPlacesMobile =
                                                      $$a.concat([$$v]))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.selectedPlacesMobile =
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        ))
                                                }
                                              } else {
                                                _vm.selectedPlacesMobile = $$c
                                              }
                                            },
                                          },
                                        }),
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(region.display) +
                                            "\n              "
                                        ),
                                      ]),
                                    ]
                                  )
                                : _vm._e()
                            }),
                          ],
                          2
                        )
                      : _vm._e()
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.premiseType, function (premise) {
                    return _vm.activeFilter === "lokal"
                      ? _c(
                          "div",
                          { staticClass: "c-office-filter__place-wrapper" },
                          [
                            _c(
                              "li",
                              { staticClass: "c-office-filter__place" },
                              [
                                _c("label", [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.selectedTypesOfBuildingsMobile,
                                        expression:
                                          "selectedTypesOfBuildingsMobile",
                                      },
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      value: premise.value,
                                      checked: Array.isArray(
                                        _vm.selectedTypesOfBuildingsMobile
                                      )
                                        ? _vm._i(
                                            _vm.selectedTypesOfBuildingsMobile,
                                            premise.value
                                          ) > -1
                                        : _vm.selectedTypesOfBuildingsMobile,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a =
                                            _vm.selectedTypesOfBuildingsMobile,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = premise.value,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.selectedTypesOfBuildingsMobile =
                                                $$a.concat([$$v]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.selectedTypesOfBuildingsMobile =
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.selectedTypesOfBuildingsMobile =
                                            $$c
                                        }
                                      },
                                    },
                                  }),
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(premise.display) +
                                      "\n              "
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        )
                      : _vm._e()
                  }),
                  _vm._v(" "),
                  _vm.activeFilter === "yta"
                    ? _c("div", [
                        _c(
                          "div",
                          { staticClass: "c-office-filter__size-input-block" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "c-office-filter__size-input-heading",
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(this.translate.selectdesiredspace) +
                                    "\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "c-office-filter__size-input-wrapper",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "c-office-filter__size-input-container",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "c-office-filter__size-input-tag",
                                      },
                                      [_vm._v("Min")]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.minSizeMobile,
                                          expression: "minSizeMobile",
                                        },
                                      ],
                                      staticClass:
                                        "c-office-filter__size-input",
                                      attrs: {
                                        type: "number",
                                        placeholder: "0",
                                      },
                                      domProps: { value: _vm.minSizeMobile },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.minSizeMobile =
                                            $event.target.value
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _vm._m(0),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "c-icon c-icon--xs c-office-filter-dropdown__toggle-icon",
                                    attrs: { "aria-hidden": "true" },
                                  },
                                  [
                                    _c("svg", [
                                      _c("use", {
                                        attrs: { "xlink:href": `#icon-minus` },
                                      }),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "c-office-filter__size-input-container",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "c-office-filter__size-input-tag",
                                      },
                                      [_vm._v("Max")]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.maxSizeMobile,
                                          expression: "maxSizeMobile",
                                        },
                                      ],
                                      staticClass:
                                        "c-office-filter__size-input",
                                      attrs: {
                                        type: "number",
                                        placeholder: "0",
                                      },
                                      domProps: { value: _vm.maxSizeMobile },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.maxSizeMobile =
                                            $event.target.value
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _vm._m(1),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.activeFilter === "arbetsplatser"
                    ? _c("div", [
                        _c(
                          "div",
                          { staticClass: "c-office-filter__size-input-block" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "c-office-filter__size-input-heading",
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      this.translate.selectdesiredworkplace
                                    ) +
                                    "\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "c-office-filter__size-input-wrapper",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "c-office-filter__size-input-container",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "c-office-filter__size-input-tag",
                                      },
                                      [_vm._v("Min")]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.minNumberOfWorkplacesMobile,
                                          expression:
                                            "minNumberOfWorkplacesMobile",
                                        },
                                      ],
                                      staticClass:
                                        "c-office-filter__size-input",
                                      attrs: {
                                        type: "number",
                                        placeholder: "0",
                                      },
                                      domProps: {
                                        value: _vm.minNumberOfWorkplacesMobile,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.minNumberOfWorkplacesMobile =
                                            $event.target.value
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "c-office-filter__size-input-m2-tag",
                                      },
                                      [_vm._v("st")]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "c-icon c-icon--xs c-office-filter-dropdown__toggle-icon",
                                    attrs: { "aria-hidden": "true" },
                                  },
                                  [
                                    _c("svg", [
                                      _c("use", {
                                        attrs: { "xlink:href": `#icon-minus` },
                                      }),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "c-office-filter__size-input-container",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "c-office-filter__size-input-tag",
                                      },
                                      [_vm._v("Max")]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.maxNumberOfWorkplacesMobile,
                                          expression:
                                            "maxNumberOfWorkplacesMobile",
                                        },
                                      ],
                                      staticClass:
                                        "c-office-filter__size-input",
                                      attrs: {
                                        type: "number",
                                        placeholder: "0",
                                      },
                                      domProps: {
                                        value: _vm.maxNumberOfWorkplacesMobile,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.maxNumberOfWorkplacesMobile =
                                            $event.target.value
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "c-office-filter__size-input-m2-tag",
                                      },
                                      [_vm._v("st")]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.activeFilter
          ? _c("div", { staticClass: "c-office-filter__button-container" }, [
              _c(
                "button",
                {
                  staticClass: "c-office-filter__button-cancel",
                  on: { click: _vm.cancelFiltersMobile },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(this.translate.cancel) +
                      "\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "c-office-filter__button-save",
                  on: { click: _vm.applyFiltersMobile },
                },
                [
                  _vm._v(
                    "\n          " + _vm._s(this.translate.use) + "\n        "
                  ),
                ]
              ),
            ])
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "resultsSection",
        staticClass: "c-office-filter__bottom-wrapper o-width-limiter--full",
      },
      [
        _c("section", { staticClass: "c-office-filter__hits" }, [
          !_vm.showMap
            ? _c("div", { staticClass: "c-office-filter__sorting-container" }, [
                _c("div", {}, [
                  _c("div", { staticClass: "c-office-filter__right-item" }, [
                    _c("span", [_vm._v(_vm._s(this.translate.sorton) + ":")]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "c-office-filter__sorting-select",
                        attrs: { id: "sorting-select" },
                        on: {
                          click: function ($event) {
                            _vm.showSortingOptions = !_vm.showSortingOptions
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.activeSorting.display) +
                            "\n              "
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "c-icon c-icon--xs c-office-filter-dropdown__toggle-icon",
                            attrs: { "aria-hidden": "true" },
                          },
                          [
                            _c("svg", [
                              _c("use", {
                                attrs: { "xlink:href": `#icon-select-arrow` },
                              }),
                            ]),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.showSortingOptions
                      ? _c(
                          "ul",
                          {
                            directives: [
                              {
                                name: "click-outside",
                                rawName: "v-click-outside",
                                value: _vm.handleClickOutside,
                                expression: "handleClickOutside",
                              },
                            ],
                            staticClass:
                              "c-office-filter__sorting-options-dropdown",
                          },
                          _vm._l(_vm.sortOptions, function (option, index) {
                            return _c(
                              "li",
                              {
                                key: index,
                                staticClass: "c-office-filter__sorting-option",
                                class: {
                                  "c-office-filter__sorting-option--active":
                                    option === _vm.activeSorting,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.selectSortingOption(option)
                                  },
                                },
                              },
                              [
                                option === _vm.activeSorting
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "c-icon c-icon--xs c-office-filter__check-icon",
                                        attrs: { "aria-hidden": "true" },
                                      },
                                      [
                                        _c("svg", [
                                          _c("use", {
                                            attrs: {
                                              "xlink:href": `#icon-check`,
                                            },
                                          }),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(option.display) +
                                    "\n              "
                                ),
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showMap && _vm.isLgDesktop
            ? _c("div", { staticClass: "c-office-filter__sorting" })
            : _vm._e(),
          _vm._v(" "),
          _c("h3", { staticClass: "c-office-filter__hits-heading" }, [
            _c("span", { staticClass: "c-office-filter__hits-number" }, [
              _vm._v(_vm._s(_vm.numberOfItems)),
            ]),
            _vm._v("\n        " + _vm._s(this.translate.premises) + "\n      "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "c-office-filter__map-toggle-group" }, [
            _c(
              "button",
              {
                staticClass:
                  "c-office-filter__toggle-button c-office-filter__toggle-button--kort",
                class: {
                  "c-office-filter__toggle-button--active": !_vm.showMap,
                },
                on: {
                  click: function ($event) {
                    _vm.showMap = false
                  },
                },
              },
              [
                _c("i", {
                  staticClass: "fa-regular fa-grid-2",
                  attrs: { "aria-hidden": "true" },
                }),
                _vm._v(" "),
                _vm.isDesktop
                  ? _c("span", [
                      _vm._v(_vm._s(this.translate.gallery || "Kort")),
                    ])
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass:
                  "c-office-filter__toggle-button c-office-filter__toggle-button--karta",
                class: {
                  "c-office-filter__toggle-button--active": _vm.showMap,
                },
                on: {
                  click: function ($event) {
                    _vm.showMap = true
                  },
                },
              },
              [
                _c("i", {
                  staticClass: "fa-regular fa-location-dot",
                  attrs: { "aria-hidden": "true" },
                }),
                _vm._v(" "),
                _vm.isDesktop
                  ? _c("span", [_vm._v(_vm._s(this.translate.map || "Karta"))])
                  : _vm._e(),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm.showMap
          ? _c(
              "div",
              { staticClass: "googlemapoffice", attrs: { id: "map" } },
              [
                _vm.showMap
                  ? _c("v-google-map", {
                      attrs: {
                        selectedPlaces: _vm.selectedPlaces,
                        selectedTypesOfBuildings: _vm.selectedTypesOfBuildings,
                        minSize: _vm.minSize,
                        maxSize: _vm.maxSize,
                        objects: this.objects,
                        apiKey: this.apiKey,
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "c-office-filter__size-input-m2-tag" }, [
      _vm._v("m"),
      _c("sup", [_vm._v("2")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "c-office-filter__size-input-m2-tag" }, [
      _vm._v("m"),
      _c("sup", [_vm._v("2")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }